import axios from 'axios'
import store from '../store'
import router from '../router'

const envApiToken = process.env.VUE_APP_API_TOKEN
const envApiFile = process.env.VUE_APP_API_FILE
const envApiImport = process.env.VUE_APP_API_IMPORT
const envApiImportProcurement = process.env.VUE_APP_API_IMPORT_PROCUREMENT
const envApiImportPreOrder = process.env.VUE_APP_API_IMPORT_PREORDER
const envApiUrl = process.env.VUE_APP_API_URL

const api = axios.create({
  baseURL: envApiUrl,
  //   responseType: 'json',
  //   timeout: 5000,
  onUploadProgress: function(progressEvent) {
    // Do whatever you want with the native progress event
  },

  // `onDownloadProgress` allows handling of progress events for downloads
  // browser only
  onDownloadProgress: function(progressEvent) {
    // Do whatever you want with the native progress event
  },
  validateStatus: function(status) {
    return status >= 200 && status < 300 // default
  }
  //   headers: {
  //     'X-Requested-With': 'XMLHttpRequest',
  //     'Access-Control-Allow-Origin': '*'
  //   },
  //   responseEncoding: 'utf8',
  //   validateStatus: function(status) {
  //     console.log(status)
  //     return status >= 200 && status < 300 // default
  //   }
})

api.interceptors.response.use(
  function(response) {
    if (response.data.code == 401) {
      router.push('/logout')
    }
    return response.data
  },
  function(error) {
    // console.log('erro: ', error.status, error.config, Promise.reject(error))
    if (error.message == 'Network Error') {
      error.message = 'เกิดข้อผิดพลาด'
    }
    return Promise.reject(error)
    // return 'เกิดข้อผิดพลาด'
    // return Promise.reject('เกิดข้อผิดพลาด')
  }
)

api.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // console.log('req: ', config)
    if (store.state.auth.token) {
      config.headers.username = store.state.auth.role.username
      config.headers.employeeId = store.state.auth.role.employee_id
      // config.headers.fullname_th = store.state.auth.info.fullname
      // config.headers.fullname_en = store.state.auth.info.fullname_en
      config.headers.accessToken = store.state.auth.token
    }
    return config
  },
  function(error) {
    // Do something with request error
    // return Promise.reject(error)
    return error
  }
)

const apiFile = axios.create({
  baseURL: envApiFile
})
apiFile.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // console.log('req: ', config)
    if (store.state.auth.token) {
      config.headers.username = store.state.auth.role.username
      config.headers.employeeId = store.state.auth.role.employee_id
      config.headers.accessToken = store.state.auth.token
    }
    return config
  },
  function(error) {
    // Do something with request error
    // return Promise.reject(error)
    return error
  }
)
const apiImport = axios.create({
  baseURL: envApiImport
})
apiImport.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // console.log('req: ', config)
    if (store.state.auth.token) {
      config.headers.username = store.state.auth.role.username
      config.headers.accessToken = store.state.auth.token
    }
    return config
  },
  function(error) {
    // Do something with request error
    // return Promise.reject(error)
    return error
  }
)
apiImport.interceptors.response.use(
  function(response) {
    if (response.data.code == 401) {
      router.push('/logout')
    }
    return response.data
  },
  function(error) {
    if (error.message == 'Network Error') {
      error.message = 'เกิดข้อผิดพลาด'
    }
    return Promise.reject(error)
  }
)
const apiImportProcurement = axios.create({
  baseURL: envApiImportProcurement
})
apiImportProcurement.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // console.log('req: ', config)
    if (store.state.auth.token) {
      config.headers.username = store.state.auth.role.username
      config.headers.accessToken = store.state.auth.token
    }
    return config
  },
  function(error) {
    // Do something with request error
    // return Promise.reject(error)
    return error
  }
)
apiImportProcurement.interceptors.response.use(
  function(response) {
    if (response.data.code == 401) {
      router.push('/logout')
    }
    return response.data
  },
  function(error) {
    if (error.message == 'Network Error') {
      error.message = 'เกิดข้อผิดพลาด'
    }
    return Promise.reject(error)
  }
)
const apiImportPreOrder = axios.create({
  baseURL: envApiImportPreOrder
})
apiImportPreOrder.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // console.log('req: ', config)
    if (store.state.auth.token) {
      config.headers.username = store.state.auth.role.username
      config.headers.accessToken = store.state.auth.token
    }
    return config
  },
  function(error) {
    // Do something with request error
    // return Promise.reject(error)
    return error
  }
)
apiImportPreOrder.interceptors.response.use(
  function(response) {
    if (response.data.code == 401) {
      router.push('/logout')
    }
    return response.data
  },
  function(error) {
    if (error.message == 'Network Error') {
      error.message = 'เกิดข้อผิดพลาด'
    }
    return Promise.reject(error)
  }
)
const apiToken = axios.create({
  baseURL: envApiToken,
  //   responseType: 'json',
  // timeout: 5000,
  validateStatus: function(status) {
    return status >= 200 && status < 300 // default
  }
  // headers: {
  //   'Content-Type': 'application/json'
  //   // 'X-Requested-With': 'XMLHttpRequest',
  //   // 'Access-Control-Allow-Origin': '*',
  //   // 'Access-Control-Allow-Headers': 'application/json, *',
  //   // 'Access-Control-Allow-Credentials': true
  // }
  //   responseEncoding: 'utf8',
  //   validateStatus: function(status) {
  //     console.log(status)
  //     return status >= 200 && status < 300 // default
  //   }
})
apiToken.interceptors.response.use(
  function(response) {
    if (response.data.code == 401) {
      router.push('/logout')
    }
    return response.data
  },
  function(error) {
    if (error.message == 'Network Error') {
      error.message = 'เกิดข้อผิดพลาด'
    }
    return Promise.reject(error)
  }
)

apiToken.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    // console.log('req: ', config)
    // if (store.state.auth.token) {
    //   config.headers.username = store.state.auth.role.username
    //   config.headers.accessToken = store.state.auth.token
    // }
    return config
  },
  function(error) {
    // Do something with request error
    // return Promise.reject(error)
    return error
  }
)

const myHeaders = async () => {
  try {
    var header = new Headers()
    header.append('accessToken', await store.state.auth.token)
    header.append('username', await store.state.auth.role.username)
    header.append('employeeId', await store.state.auth.role.employee_id)
    return header
  } catch (error) {
    console.log('error in myheaders: ', error)
  }
}

// var myHeaders = new Headers()
// myHeaders.append('accessToken', store.state.auth.token)
// myHeaders.append('username', store.state.auth.role.username)

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'

// const httpFile = axios.create({
//   baseURL: 'https://some-domain.com/api/',
//   timeout: 5000,
//   headers: { 'X-Requested-With': 'XMLHttpRequest' }
// })

export {
  apiToken,
  api,
  apiFile,
  apiImport,
  apiImportProcurement,
  apiImportPreOrder,
  myHeaders
  //   httpFile
}
